import React from "react";

interface StepNavItemProps {
  step: number;
  stepName: string;
  currentStep: number;
}

export const StepNavItem = (props: StepNavItemProps) => {
  const { step, stepName, currentStep } = props;

  return (
    <div
      className={[
        'flex-grow w-1/5 text-white text-lg font-extrabold border-r border-white flex flex-col items-start p-2',
        currentStep === step ? 'bg-blue-400' : '',
        currentStep > step ? 'bg-green-400' : '',
        currentStep < step ? 'bg-gray-500' : '',
      ].join(' ')}
    >
      <p className="ml-1">STEP{ step }</p>
      <p className="ml-1">{ stepName }</p>
    </div>
  )
}